export default {
  path: 'personalTax',
  component: () => import( /* webpackChunkName: "individual-list" */ '@/pages/personalTax/List'),
  meta: {
    title: '个人完税记录'
  },
  children: [
	{
	path: 'detail',
	component: () => import( /* webpackChunkName: "individual-view" */ '@/pages/personalTax/Detail'),
	meta: {
		title: '个人完税'
	}
	}
  ]
}